
jQuery('.currencies li').on('click', function(event) {
  event.preventDefault();
  jQuery('.currencies li').removeClass('active');
  jQuery(this).addClass('active');

  var selectedValue = jQuery(this).find('input[type=hidden]').val();

  jQuery('.currencies_src option').attr('selected', false);
  jQuery('.currencies_src option[value=' + selectedValue + ']').attr('selected', true);

  var sourceCurrency = Currency.currentCurrency || shopCurrency || defaultCurrency;

  if (sourceCurrency && selectedValue) {
    Currency.convertAll(sourceCurrency, selectedValue);
  }

  jQuery('.currency_code').html(jQuery(this).find('a').html());
});

var shopCurrency = '';
var defaultCurrency = '';
var cookieCurrency = '';
var supportedCurrencies = ' AUD'.split(/\s+/);

function isSupportedCurrency(currency) {
  return currency && jQuery.inArray(currency, supportedCurrencies) !== -1;
}

function getCurrencyFormat(formatName, currency) {
  var formats = Currency[formatName || Currency.format] || Currency[Currency.format] || Currency.money_with_currency_format || {};
  return formats[currency] || ('{' + '{amount}' + '}');
}

function getMoneyDataCents(moneyElement) {
  var cents = moneyElement.attr('data-cents') || moneyElement.closest('[data-cents]').attr('data-cents');
  var parsedCents = parseInt(cents, 10);

  if (isNaN(parsedCents)) {
    return null;
  }

  return parsedCents;
}

function getMoneyCentsFromHtml(html, sourceFormat, moneyElement) {
  var dataCents = moneyElement ? getMoneyDataCents(moneyElement) : null;

  if (dataCents !== null) {
    return dataCents;
  }

  var digits = String(html || '').replace(/[^0-9]/g, '');

  if (digits === '') {
    return null;
  }

  var cents = parseInt(digits, 10);

  if (isNaN(cents)) {
    return null;
  }

  if (String(sourceFormat || '').indexOf('amount_no_decimals') !== -1) {
    cents = cents * 100;
  }

  return cents;
}

function restoreMoneyElement(moneyElement, fallbackHtml) {
  var cents = getMoneyDataCents(moneyElement);

  if (cents === null) {
    moneyElement.html(fallbackHtml);
    return fallbackHtml;
  }

  var restoredHtml = Currency.formatMoney(cents, getCurrencyFormat('money_format', shopCurrency));
  moneyElement.html(restoredHtml);
  return restoredHtml;
}

function installSafeCurrencyConverter() {
  var originalConvertAll = Currency.convertAll;

  Currency.convertAll = function(sourceCurrency, targetCurrency, selector, formatName) {
    var formatKey = formatName || Currency.format;
    var sourceFormat = getCurrencyFormat(formatKey, sourceCurrency);
    var targetFormat = getCurrencyFormat(formatKey, targetCurrency);

    if (!sourceCurrency || !targetCurrency) {
      return;
    }

    jQuery(selector || 'span.money').each(function() {
      var moneyElement = jQuery(this);
      var sourceAttr = 'data-currency-' + sourceCurrency;
      var targetAttr = 'data-currency-' + targetCurrency;
      var sourceHtml = moneyElement.attr(sourceAttr) || moneyElement.html();

      if (sourceCurrency === targetCurrency) {
        if (sourceHtml && sourceHtml.indexOf('NaN') === -1) {
          moneyElement.html(sourceHtml);
        } else {
          restoreMoneyElement(moneyElement, sourceHtml);
        }

        moneyElement.attr('data-currency', targetCurrency);
        return;
      }

      if (moneyElement.attr('data-currency') === targetCurrency) {
        if (String(moneyElement.html()).indexOf('NaN') !== -1) {
          restoreMoneyElement(moneyElement, sourceHtml);
        }

        return;
      }

      var cachedTargetHtml = moneyElement.attr(targetAttr);

      if (cachedTargetHtml && cachedTargetHtml.indexOf('NaN') === -1) {
        moneyElement.html(cachedTargetHtml);
        moneyElement.attr('data-currency', targetCurrency);
        return;
      }

      var cents = getMoneyCentsFromHtml(sourceHtml, sourceFormat, moneyElement);

      if (cents === null || typeof Currency.convert !== 'function') {
        if (String(sourceHtml).indexOf('NaN') !== -1) {
          sourceHtml = restoreMoneyElement(moneyElement, sourceHtml);
        } else {
          moneyElement.html(sourceHtml);
        }

        moneyElement.attr('data-currency', sourceCurrency);
        return;
      }

      var convertedCents = Currency.convert(cents, sourceCurrency, targetCurrency);

      if (isNaN(convertedCents)) {
        if (String(sourceHtml).indexOf('NaN') !== -1) {
          sourceHtml = restoreMoneyElement(moneyElement, sourceHtml);
        } else {
          moneyElement.html(sourceHtml);
        }

        moneyElement.attr('data-currency', sourceCurrency);
        return;
      }

      var convertedHtml = Currency.formatMoney(convertedCents, targetFormat);

      if (String(convertedHtml).indexOf('NaN') !== -1) {
        if (String(sourceHtml).indexOf('NaN') !== -1) {
          sourceHtml = restoreMoneyElement(moneyElement, sourceHtml);
        } else {
          moneyElement.html(sourceHtml);
        }

        moneyElement.attr('data-currency', sourceCurrency);
        return;
      }

      moneyElement.html(convertedHtml);
      moneyElement.attr(targetAttr, convertedHtml);
      moneyElement.attr('data-currency', targetCurrency);
    });

    Currency.currentCurrency = targetCurrency;

    if (Currency.cookie && typeof Currency.cookie.write === 'function') {
      Currency.cookie.write(targetCurrency);
    }
  };

  Currency.convertAll.originalConvertAll = originalConvertAll;
}

installSafeCurrencyConverter();

currenciesCallback();

function currenciesCallback() {
  
    Currency.format = 'money_with_currency_format';
  

  shopCurrency = '';

  Currency.money_with_currency_format[shopCurrency] = "";
  Currency.money_format[shopCurrency] = "";

  defaultCurrency = 'AUD' || shopCurrency;
  cookieCurrency = Currency.cookie.read();

  if (cookieCurrency && !isSupportedCurrency(cookieCurrency)) {
    cookieCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
  }

  jQuery('span.money span.money').each(function() {
    jQuery(this).parents('span.money').removeClass('money');
  });

  jQuery('span.money').each(function() {
    var moneyElement = jQuery(this);
    var sourceHtml = moneyElement.html();

    if (String(sourceHtml).indexOf('NaN') !== -1) {
      sourceHtml = restoreMoneyElement(moneyElement, sourceHtml);
    }

    moneyElement.attr('data-currency-', sourceHtml);
  });

  if (cookieCurrency == null) {
    if (shopCurrency !== defaultCurrency) {
      Currency.convertAll(shopCurrency, defaultCurrency);
    } else {
      Currency.currentCurrency = defaultCurrency;
    }
    Currency.cookie.write(defaultCurrency);
  } else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
    Currency.currentCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
  } else if (cookieCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  } else {
    Currency.convertAll(shopCurrency, cookieCurrency);

    jQuery('.currencies li').removeClass('active');
    jQuery('.currencies .currency-' + cookieCurrency).addClass('active');
    jQuery('.currency_code').html(jQuery('.currencies .currency-' + cookieCurrency).find('a').html());
  }

  jQuery('.currencies_src').on('change', function(e) {
    var newCurrency = jQuery(e.currentTarget).find(':selected').attr('value');
    jQuery('.selected-currency').text(Currency.currentCurrency);

    if (jQuery('.templateProduct').length !== 0 && typeof updatePricing === 'function') {
      updatePricing();
    }

    return newCurrency;
  });
}

function currenciesCallbackSpecial(id) {
  var targetCurrency = Currency.cookie.read() || Currency.currentCurrency || defaultCurrency || shopCurrency;

  if (!targetCurrency || !shopCurrency) {
    return;
  }

  jQuery(id).each(function() {
    var moneyElement = jQuery(this);
    var sourceHtml = moneyElement.html();

    if (String(sourceHtml).indexOf('NaN') !== -1) {
      sourceHtml = restoreMoneyElement(moneyElement, sourceHtml);
    }

    moneyElement.attr('data-currency-', sourceHtml);
  });

  if (targetCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
    return;
  }

  Currency.convertAll(shopCurrency, targetCurrency, id, 'money_with_currency_format');
}

